import React, { useState } from "react";

import Loader from "../Loader";
import Error from "../Error";
import { sendRequest } from "../../api";

export const Upgrade = () => {
  const [error, setError] = useState(null);

  (async () => {
    try {
      const { url } = await sendRequest("/payments", "POST");
      window.location.href = url;
    } catch (error) {
      setError(error.message);
    }
  })();

  return error ? <Error message={error} /> : <Loader />;
};

export default Upgrade;